<template>
    <v-container class="d-flex justify-center align-center pa-0 fill-height">
        <v-icon color="primary" :icon="icons.mdiRestart" class="cursor-pointer"/>
    </v-container>
</template>

<script setup>
    import {mdiRestart} from '@mdi/js';

    const icons = {
        mdiRestart
    };
</script>
